import axios from 'axios'
import qs from 'qs'
import { getToken } from '@/utils/auth'
import store from '@/store/'
import { API_PREFIX as baseURL } from '@/config'

const instance = axios.create({ baseURL })

function doExec (url, params, contentType, method) {

    contentType = (contentType || 'JSON').toUpperCase()
    method = (method || 'POST').toUpperCase()
    
    const pstrMethods = ['GET', 'DELETE']
    // url需要拼接参数的方法
    if (pstrMethods.indexOf(method) != -1) {
        let pstr = qs.stringify(params, {
            arrayFormat: 'brackets'
        })
        url = `${url}?${pstr}`
    }
    // 缓存刷新，特别是ie!!!!
    url = url.indexOf('?') == -1 ? `${url}?t=${new Date().getTime()}` : `${url}&t=${new Date().getTime()}`

    return instance({
        url,
        params: null,
        data: contentType == 'JSON' ? params : qs.stringify(params),
        method,
        headers: {
            token: getToken() ?? ''
        }
    }).then(res => {
        if(res.data.errCode == 401) {
            store.dispatch('logout')
            return null
        }
        return res.data
    }).catch(res => {
        if(res.response.status == 403 || res.response.status == 401) {
            store.dispatch('logout')
        } else {
            console.log(res.response)
        }
    })
}


export {
    doExec
}